var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v("Profiling (Enkel voor developers)")]),
      _c(
        "w-list",
        [
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [_vm._v("Collect heap")]),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.collectingHeap },
                      on: {
                        click: function ($event) {
                          return _vm.collectHeap()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "play" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [_vm._v("Collect CPU")]),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.collectingCpu },
                      on: {
                        click: function ($event) {
                          return _vm.collectCpu()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "play" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [_vm._v("Collect goroutine")]),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.collectingGoRoutines },
                      on: {
                        click: function ($event) {
                          return _vm.collectGoRoutines()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "play" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item",
            [
              _c("w-list-item-text", [_vm._v("Collect garbage")]),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.collectingGarbage },
                      on: {
                        click: function ($event) {
                          return _vm.collectGarbage()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "play" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }